import { css } from '@emotion/core';

import colors from '../config/colors';
import { mobileMediaQuery, orientationLandscape } from '../config/mediaQuery';

const login = css`
  .mobile-login {
    height: 80px;
    background: ${colors.mobileGreen};
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    & h1 {
      color: #FFFFFF;
      margin: 0;
      font-size: 1.5em;
      line-height: 24;
      font-weight: 700;
      line-height: 1.5em;
      letter-spacing: 0em;
    }
  }
  .mobile-login-form {
    ${orientationLandscape} {
      margin-top: 110px;
    }
    margin-top: 80px;
    max-width: 400px;
    width: 100%;
    height: calc(100vh - 80px);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    form {
      width: 95%;
      button {
        width: 100%;
      }
    }
    & h1 {
      font-family: Lato;
      font-size: 1.5em;
      font-weight: 700;
      line-height: 1.8125em;
      letter-spacing: 0em;
      margin: 0;
      color: #111827;
    }
    & p {
      font-family: Lato;
      font-size: 0.875em;
      font-weight: 400;
      line-height: 1.125em;
      letter-spacing: 0em;
      color: #6B7280;
      margin-bottom: 2em;
    }
    & input {
      height: 2.8125em;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid #E5E7EB;
    }
    & input::placeholder {
      height: 1.0625em;
      font-family: Lato;
      weight: 400;
    }
    & label {
      font-family: Lato;
      weight: 700;
      font-size: 0.875em;
      color: #111827;
      margin-bottom: 0.5em;
    }
    & .login-button {
      ${mobileMediaQuery} {
        background-color: ${colors.mobileGreen};
        height: 2.625em;
        font-size: 1em;
        font-family: Lato;
        border: none;
        border-radius: 4px;
        color: ${colors.white};
        margin-top: 1em;
      }
    }
  }
`;

export { login };
